import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import Header from './modules/_header.js';
import Flyout from './modules/_flyout.js';
import StateProfile from './modules/_state-profile.js';
import './base/_smoothScroll.js';
import './base/_object-fit-cover.js';
import { combobox } from './base/_combobox.js';

class Scripts {
	constructor() {
		window.aga = window.aga || {};
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();
	}

	ready() {
		focusWithin( 'label, form, fieldset' );

		this.header = new Header();
		this.flyout = new Flyout();
		this.cookieNotice();
		combobox();

		if ( this.header.hamburger ) {
			this.header.hamburger.addEventListener('click', () => this.flyout.open('menu'));
		}

		if ( this.header.search ) {
			this.header.search.addEventListener('click', () => this.flyout.open('search'));
		}

		const group = document.querySelector( '.main__wrap > .wp-block-group:last-child' );
		if ( group ) {
			group.classList.add( 'group-last' );
		}

		// State profile page.
		if (document.querySelector('.state-profile-data')) {
			this.stateProfile = new StateProfile(
				window.aga.customerComparisonData, 
				window.aga.consumptionComparisonData
			);
		}
	}

	resize() {
		if ( ! document.body ) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}

	cookieNotice() {
		const cookieNotice = document.querySelector('.cookie-notice');

		if ( ! cookieNotice ) {
			return;
		}

		const cookieName = 'cookieNotice';

		if ( document.cookie.match( new RegExp( `\\b${cookieName}=\\d+\\b` ) ) ) {
			cookieNotice.parentNode.removeChild(cookieNotice);
			return;
		}

		cookieNotice.removeAttribute('hidden');

		const cookieNoticeAccept = cookieNotice.querySelector('button');

		if ( ! cookieNoticeAccept ) {
			return;
		}

		cookieNoticeAccept.addEventListener('click', () => {
			document.cookie = `cookieNotice=${Date.now()}; max-age=${5 * 365 * 24 * 60 * 60}; path=/`; // five-ish years duration
			cookieNotice.parentNode.removeChild(cookieNotice);
		});
	}
}

export default new Scripts;
